import { CmsObjectWithDefault } from '@components/Cms/types';
import { cmsIds } from 'prebuild.data';

export type ProfileFormCmsKey =
    | 'ProfileTitle'
    | 'FirstnameLabel'
    | 'LastnameLabel'
    | 'FirstnameValidationFormat'
    | 'LastnameValidationFormat'
    | 'DataPrivacyPolicyHeader'
    | 'PleaseAcceptConsent'
    | 'ConsentAll'
    | 'ConsentAgreeTermsOfService'
    | 'ConsentPrivacyPolicy'
    | 'ConsentThirdPartyPolicy'
    | 'Required'
    | 'Link'
    | 'Continue'
    | 'ReceiveUpdate'
    | 'ProfileSubtitle'
    | 'ProfileSubTitleNoEmail'
    | 'PhoneNumberLabel'
    | 'OptionalLabel';

export const ProfileFormCmsWithDefault: CmsObjectWithDefault<ProfileFormCmsKey> = {
    ProfileTitle: {
        cmsId: 331886,
        defaultTranslation: 'First, tell us your preferred name.',
    },
    ProfileSubtitle: {
        cmsId: 336890,
        defaultTranslation:
            "We're setting up your account for {0}. Please let us know your preferred name to get started",
    },
    ProfileSubTitleNoEmail: {
        cmsId: 417392,
        defaultTranslation: "We're setting up your account. Please let us know your preferred name to get started",
    },
    FirstnameLabel: {
        cmsId: 68344,
        defaultTranslation: 'First name',
    },
    LastnameLabel: {
        cmsId: 68345,
        defaultTranslation: 'Last name',
    },
    FirstnameValidationFormat: {
        cmsId: 76301,
        defaultTranslation: 'Please enter a valid first name (English only)',
    },
    LastnameValidationFormat: {
        cmsId: 76302,
        defaultTranslation: 'Please enter a valid last name (English only)',
    },
    PhoneNumberLabel: {
        cmsId: 289854, // Using a new ID
        defaultTranslation: 'Phone number',
    },
    OptionalLabel: {
        cmsId: 69770,
        defaultTranslation: '(optional)',
    },
    DataPrivacyPolicyHeader: {
        cmsId: 139901,
        defaultTranslation: 'Your data privacy policy',
    },
    PleaseAcceptConsent: {
        cmsId: 139902,
        defaultTranslation: 'Please accept all privacy policy consent to process the booking',
    },
    ConsentAll: {
        cmsId: 139968,
        defaultTranslation: 'I consent to all of below privacy policy',
    },
    ConsentAgreeTermsOfService: {
        cmsId: 139903,
        defaultTranslation: 'I agree to the Terms of Service, and I confirm that I am 18 years or older',
    },
    ConsentPrivacyPolicy: {
        cmsId: 139905,
        defaultTranslation:
            'I consent to the collection and use of my personal information in accordance with the Privacy Policy',
    },
    ConsentThirdPartyPolicy: {
        cmsId: 139906,
        defaultTranslation:
            'I consent to the third-party provision, either in Korea or overseas, of my personal information in accordance with the Privacy Policy',
    },
    Required: {
        cmsId: 139904,
        defaultTranslation: '[Required]',
    },
    Link: {
        cmsId: 139907,
        defaultTranslation: '(Link)',
    },
    Continue: {
        cmsId: 208940,
        defaultTranslation: 'Continue',
    },
    ReceiveUpdate: {
        cmsId: 76299,
        defaultTranslation:
            'I agree to receive updates and promotions about Agoda and its affiliate or business partners via various channels, including WhatsApp. Opt-out anytime. Read more on the Privacy Policy.',
    },
};
